import React from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    mb,
    mt,
    onDesktop,
    p,
    w100
} from "@pg-design/helpers-css";
import {BrandCoinIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {formatBigNumbers} from "../../../utils/format_big_numbers";
import {IconWithElement} from "../../IconWithElement";

const expertImg = require("../../../images/expert.png");

interface IProps {
    onButtonClick?: () => void;
    onRedirect?: () => void;
    installment: number | string | null;
    hideBottomSection?: boolean;
    customizedBoxWrapper?: SerializedStyles;
    smallTopSection?: boolean;
    customDescription?: React.ReactNode;
    currency?: string;
}

export const InstallmentBox = (props: IProps) => {
    const {onButtonClick, onRedirect, installment, hideBottomSection, customizedBoxWrapper, smallTopSection, customDescription, currency} = props;
    const iconProps = {
        size: "6.4",
        wrapperSize: "6.4",
        wrapperColor: "transparent"
    };

    const formattedInstallment = typeof installment === "number" && formatBigNumbers(installment);

    return (
        <div css={customizedBoxWrapper || boxWrapper}>
            <InstallmentBoxTop hideBottomSection={hideBottomSection}>
                <Text as="p" variant="headline_5" align="center" css={mb(smallTopSection ? 2 : 4)}>
                    Twoja miesięczna
                    {smallTopSection ? " " : <br />}
                    rata kredytu
                </Text>

                <IconWithElement icon={BrandCoinIcon} iconProps={iconProps} containerStyle={iconWithElementStyle}>
                    <Text variant="headline_0" as="p">
                        <strong>{formattedInstallment || "-"}</strong>{" "}
                        <Text variant="headline_6" as="span">
                            {currency || "zł"}
                        </Text>
                    </Text>
                </IconWithElement>

                {customDescription}
            </InstallmentBoxTop>

            {!hideBottomSection && (
                <div css={installmentBoxBottom}>
                    <div css={textSectionStyle}>
                        <Image src={expertImg} alt="Zdjęcie eksperta" width="94px" height="56px" css={expertImage} />

                        <div>
                            <Text variant="body_copy_1" strong css={mb(1)}>
                                Skorzystaj z bezpłatnej porady
                            </Text>
                            <Text variant="info_txt_1">
                                Ekspert Credipass wyszuka dla Ciebie najbardziej optymalne rozwiązania kredytowe i pomoże załatwić formalności na dalszym etapie
                                procesu.
                            </Text>
                        </div>
                    </div>

                    <Button variant="filled_primary" size="small" css={w100} onClick={onButtonClick}>
                        <Text variant="button_small">umów się na rozmowę</Text>
                    </Button>

                    {onRedirect && (
                        <Button variant="outlined_secondary" size="small" css={[w100, mt(2)]} onClick={onRedirect}>
                            <Text variant="button_small">Zobacz oferty banków</Text>
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const boxWrapper = css`
    ${borderRadius(2)};
    ${mt(3)};
    ${maxWidth("360px")};

    ${onDesktop(mt(4))};
`;

const InstallmentBoxTop = styled.div<{hideBottomSection?: boolean}>`
    ${(props) => backgroundColor(props.theme.colors.success)};
    ${(props) => (props.hideBottomSection ? borderRadius(2) : borderRadius(2, 2, 0, 0))};
    ${p(3)};
`;

const iconWithElementStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("row")};
`;

const installmentBoxBottom = (theme: Theme) => css`
    ${backgroundColor(theme.colors.background[100])};
    ${borderRadius(0, 0, 2, 2)};
    ${p(4, 2, 2, 2)};
`;

const textSectionStyle = css`
    ${flex("flex-start", "center")};
    gap: ${calculateRemSize(1)};
    ${mb(3)};
`;

const expertImage = css`
    ${flexAbsoluteCenter};
    border-radius: 50%;
    min-width: ${calculateRemSize(7)};
    min-height: ${calculateRemSize(7)};
`;
import React from "react";
import {css, SerializedStyles, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {
    backgroundColor,
    borderRadius,
    calculateRemSize,
    flex,
    flexAbsoluteCenter,
    flexDirection,
    maxWidth,
    mb,
    mt,
    onDesktop,
    p,
    w100
} from "@pg-design/helpers-css";
import {BrandCoinIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {formatBigNumbers} from "../../../utils/format_big_numbers";
import {IconWithElement} from "../../IconWithElement";

const expertImg = require("../../../images/expert.png");

interface IProps {
    onButtonClick?: () => void;
    onRedirect?: () => void;
    installment: number | string | null;
    hideBottomSection?: boolean;
    customizedBoxWrapper?: SerializedStyles;
    smallTopSection?: boolean;
    customDescription?: React.ReactNode;
    currency?: string;
}

export const InstallmentBox = (props: IProps) => {
    const {onButtonClick, onRedirect, installment, hideBottomSection, customizedBoxWrapper, smallTopSection, customDescription, currency} = props;
    const iconProps = {
        size: "6.4",
        wrapperSize: "6.4",
        wrapperColor: "transparent"
    };

    const formattedInstallment = typeof installment === "number" && formatBigNumbers(installment);

    return (
        <div css={customizedBoxWrapper || boxWrapper}>
            <InstallmentBoxTop hideBottomSection={hideBottomSection}>
                <Text as="p" variant="headline_5" align="center" css={mb(smallTopSection ? 2 : 4)}>
                    Twoja miesięczna
                    {smallTopSection ? " " : <br />}
                    rata kredytu
                </Text>

                <IconWithElement icon={BrandCoinIcon} iconProps={iconProps} containerStyle={iconWithElementStyle}>
                    <Text variant="headline_0" as="p">
                        <strong>{formattedInstallment || "-"}</strong>{" "}
                        <Text variant="headline_6" as="span">
                            {currency || "zł"}
                        </Text>
                    </Text>
                </IconWithElement>

                {customDescription}
            </InstallmentBoxTop>

            {!hideBottomSection && (
                <div css={installmentBoxBottom}>
                    <div css={textSectionStyle}>
                        <Image src={expertImg} alt="Zdjęcie eksperta" width="94px" height="56px" css={expertImage} />

                        <div>
                            <Text variant="body_copy_1" strong css={mb(1)}>
                                Skorzystaj z bezpłatnej porady
                            </Text>
                            <Text variant="info_txt_1">
                                Ekspert Credipass wyszuka dla Ciebie najbardziej optymalne rozwiązania kredytowe i pomoże załatwić formalności na dalszym etapie
                                procesu.
                            </Text>
                        </div>
                    </div>

                    <Button variant="filled_primary" size="small" css={w100} onClick={onButtonClick}>
                        <Text variant="button_small">umów się na rozmowę</Text>
                    </Button>

                    {onRedirect && (
                        <Button variant="outlined_secondary" size="small" css={[w100, mt(2)]} onClick={onRedirect}>
                            <Text variant="button_small">Zobacz oferty banków</Text>
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

const boxWrapper = css`
    ${borderRadius(2)};
    ${mt(3)};
    ${maxWidth("360px")};

    ${onDesktop(mt(4))};
`;

const InstallmentBoxTop = styled.div<{hideBottomSection?: boolean}>`
    ${(props) => backgroundColor(props.theme.colors.success)};
    ${(props) => (props.hideBottomSection ? borderRadius(2) : borderRadius(2, 2, 0, 0))};
    ${p(3)};
`;

const iconWithElementStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("row")};
`;

const installmentBoxBottom = (theme: Theme) => css`
    ${backgroundColor(theme.colors.background[100])};
    ${borderRadius(0, 0, 2, 2)};
    ${p(4, 2, 2, 2)};
`;

const textSectionStyle = css`
    ${flex("flex-start", "center")};
    gap: ${calculateRemSize(1)};
    ${mb(3)};
`;

const expertImage = css`
    ${flexAbsoluteCenter};
    border-radius: 50%;
    min-width: ${calculateRemSize(7)};
    min-height: ${calculateRemSize(7)};
`;
